import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';


class CustomerRow extends Component {
	constructor() {
		super();
//		this.handleClick = this.handleClick.bind(this);
	}
	
//	handleClick(e) {
//		this.setState({finishing: true});
//		this.props.actions(this.props.id, this.props.task, this.props.state);
//	}
	
	render() {
	
	return (
			<TableRow key={this.props.id}>
			<TableCell>{this.props.id}</TableCell>
			<TableCell>{this.props.idOdoo}</TableCell>
			<TableCell>{this.props.name}</TableCell>
			<TableCell><Link style={{textDecoration: 'none'}} to={`/customerForm/${this.props.id}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: "#000", cursor: "pointer"}}>&#59404;</Icon></Link></TableCell>
			</TableRow>
		);
	}
}

export default CustomerRow;